import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import HorizontalMenu from '../horizontalMenu';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class Header extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { onMobileNavToggle, onSideNavToggle, onToolsToggle, currentUser, onLogout, franchisor, releaseNotes, languages, t } = this.props;
		const logoImg = franchisor && franchisor.logoUrl;

		return (
			<div className='navbar navbar-inverse navbar-fixed-top'>
				<div className='container'>
					<div className='navbar-header'>
						<button className='navbar-toggle' type='button' style={{ float: 'left' }} onClick={onMobileNavToggle}>
							<span className='clip-list-2' />
						</button>
						<button className='navbar-toggle visible-desktop' type='button' style={{ float: 'left' }} onClick={onSideNavToggle}>
							<span className='clip-list-2' />
						</button>
						<button className='navbar-toggle' type='button' onClick={onToolsToggle}>
							<span className='clip-menu-2' />
						</button>
						{logoImg && <Link className='logo' to='/'><img src={logoImg} /></Link>}
						{!logoImg && <Link className='navbar-brand' to='/'>{t('Admin_Title', { systemName: franchisor && franchisor.systemName.toUpperCase() })}</Link>}
					</div>
					<div className='navbar-tools clearfix'>
						<HorizontalMenu currentUser={currentUser} onLogout={onLogout} releaseNotes={releaseNotes} languages={languages} />
					</div>
				</div>
			</div>
		);
	}

}
const mapStateToProps = state => {
	const { configuration: { franchisor, releaseNotes }, lookups: { languages } } = state;

	return {
		franchisor,
		releaseNotes,
		languages
	};
};

export default withRouter(connect(mapStateToProps, {})(withTranslation()(Header)));